/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-unknown-property */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-undef */
import React, { useEffect, useState } from "react";
import { User } from "react-feather";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next"; // For translation
import Loader from "react-js-loader";
import { Link, useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import useLogoutSubmit from "../../core/hooks/useLogoutSubmit";
import useUserSubmit from "../../core/hooks/useUserSubmit";
import { all_routes } from "../../Router/all_routes";
import ImageWithBasePath from "../general/ImageCustom";
import SwitchLanguage from "./SwitchLanguage";
import SelectStore from "./SelectStore";
import useHeaderStore from "../../store/header";
import { useMetaContext } from "../../Router/MetaContext";
const Header = () => {
  const { rootContext, setCompanies } = useHeaderStore()
  const { t } = useTranslation(); // Translation
  const { metadata, loadingImport } = useMetaContext();
  let navigate = useNavigate();
  const { onLogout } = useLogoutSubmit(navigate);
  const { getValues, imageSrc } = useUserSubmit();

  const { handleSubmit } = useForm();
  const route = all_routes;
  const [toggle, SetToggle] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const isElementVisible = (element) => {
    return element?.offsetWidth > 0 || element?.offsetHeight > 0;
  };

  useEffect(() => {
    const handleMouseover = (e) => {
      e.stopPropagation();

      const body = document.body;
      const toggleBtn = document.getElementById("toggle_btn");

      if (
        body.classList.contains("mini-sidebar") &&
        isElementVisible(toggleBtn)
      ) {
        e.preventDefault();
      }
    };

    document.addEventListener("mouseover", handleMouseover);

    return () => {
      document.removeEventListener("mouseover", handleMouseover);
    };
  }, []);

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(
        document.fullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement
      );
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("mozfullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("msfullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener(
        "mozfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "msfullscreenchange",
        handleFullscreenChange
      );
    };
  }, []);

  const exclusionArray = [
    "/reactjs/template/dream-pos/index-three",
    "/reactjs/template/dream-pos/index-one",
  ];
  if (exclusionArray.indexOf(window.location.pathname) >= 0) {
    return "";
  }

  return (
    <>
      <div className="header fixed w-full">
        <div className={`header-left flex !justify-between !px-[38px] ${toggle ? "" : "active"}`}>
          <Link
            onClick={(e) => {
              e.preventDefault()
              navigate("/sales-dashboard?menu=dboard");
            }}
            className="logo logo-normal"
          >
            {metadata &&
              (!loadingImport ? (
                <div className="flex items-center justify-center gap-[16px]">
                  <div className="flex items-start">
                    <img
                      src={metadata?.logo}
                      alt='logo'
                      width={100}
                      height={40}
                      className='h-auto max-h-[40px] object-contain object-top'
                    />
                  </div>
                </div>
              ) : (
                <ImageWithBasePath
                  src="../../../public/assets/logo/vitrust-white.svg"
                  alt="img"
                />
              ))}
          </Link>
          <Link
            onClick={() => navigate("/sales-dashboard?menu=dboard")}
            className="logo logo-white"
          >
            <ImageWithBasePath src="assets/logo/vitrust-three.svg" alt="img" />
          </Link>
          <Link
            onClick={() => navigate("/sales-dashboard?menu=dboard")}
            className="logo-small"
          >
            <ImageWithBasePath src={metadata?.logo || ''} alt="img" />
          </Link>
        </div>

        <ul className="nav user-menu bg-white border-b border-[#E8E8E8] px-6 !justify-between">
          <li className="nav-item dropdown has-arrow main-drop select-store-dropdown">
            <SelectStore />
          </li>
          <li className="nav-item nav-item-box">
            <ImageWithBasePath
              src="assets/img/header/glass-search.svg"
              alt="glass-search"
              width={24}
              height={24}
            />
          </li>
          <li className="nav-item nav-item-box">
            <ImageWithBasePath
              src="assets/img/header/bell.svg"
              alt="bell"
              width={24}
              height={24}
            />
          </li>
          <li className="nav-item nav-item-box">
            <Link to="/pos-session">
              <FeatherIcon icon="shopping-cart" />
            </Link>
          </li>
          <li>
            <SwitchLanguage />
          </li>
          <li className="nav-item dropdown has-arrow main-drop">
            <Link
              to="#"
              className="dropdown-toggle nav-link userset"
              data-bs-toggle="dropdown"
            >
              <span className="user-info">
                <span className="user-letter">
                  {imageSrc ? (
                    <img
                      src={imageSrc}
                      alt="img"
                      className="img-fluid w-100 h-100"
                    />
                  ) : (
                    <Loader
                      type="ping-cube"
                      color="#ED1C24"
                      bgColor="#ED1C24"
                      size={30}
                    />
                  )}

                </span>
                {/* <span className='user-detail'>
                  <span className='user-name'>{getValues('name')}</span>
                  <span className='user-role'>{getValues('email')}</span>
                </span> */}
              </span>
            </Link>
            <div className="dropdown-menu menu-drop-user">
              <div className="profilename">
                <hr className="m-0" />
                <Link className="dropdown-item" to={route.profile}>
                  <User className="me-2" />
                  My profile
                  {/* {t("my_profile")} */}
                </Link>
                <hr className="m-0" />
                <form onSubmit={handleSubmit(onLogout)}>
                  <button
                    type="submit"
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                      display: "inline",
                      padding: "0px",
                      width: "100%",
                    }}
                  >
                    <div className="dropdown-item logout pb-0">
                      <ImageWithBasePath
                        src="assets/img/icons/log-out.svg"
                        alt="img"
                        className="me-2"
                      />{" "}
                      {/* {t("logout")} */}
                      Log out
                    </div>
                  </button>
                </form>
              </div>
            </div>
          </li>
        </ul>
        {/* /Header Menu */}
        {/* Mobile Menu */}
        <div className="dropdown mobile-user-menu">
          <Link
            to="#"
            className="nav-link dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v" />
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link className="dropdown-item" to="profile">
              {t("my_profile")}
            </Link>
            <Link className="dropdown-item" to="generalsettings">
              {t("settings")}
            </Link>
            <form onSubmit={handleSubmit(onLogout)}>
              <button
                type="submit"
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  display: "inline",
                  padding: "0px",
                  width: "100%",
                }}
              >
                <div className="dropdown-item logout pb-0">
                  <ImageWithBasePath
                    src="assets/img/icons/log-out.svg"
                    alt="img"
                    className="me-2"
                  />{" "}
                  {t("logout")}
                </div>
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
